export const SUCCESS_DASHBOARD = "SUCCESS_DASHBOARD";